module.exports = {
  finance_inputBusinessNumber: 'Введите номер операции',
  finance_query: 'Поиск',
  finance_view: 'Просмотр',
  finance_returnQuery: 'Вернуться к поиску',
  finance_batchAudit: 'Массовая проверка',
  finance_lockTheBill: 'Блокировка заказа',
  finance_accrue: 'Начисление',
  finance_businessCommission: 'Комиссия за операцию',
  finance_cancelAccrue: 'Отмена начисления',
  finance_print: 'Печать',
  finance_audit: 'Проверка',
  finance_cancelTheAudit: 'Отмена проверки',
  finance_chargesAudit: 'Проверка расходов',
  finance_cancelTheChargesAudit: 'Отмена проверки расходов',
  finance_printTheProfit: 'Печать прибыли',
  finance_editFinancialDate: 'Изменение финансовой даты',
  finance_businessAdjustment: 'Корректировка операции',
  finance_editChargeFinancialDate: 'Изменение финансовой даты расходов',
  finance_basic: 'Основное',
  finance_booking: 'Бронирование',
  finance_charges: 'Расходы',
  finance_domesticBill: 'Внутренний счет',
  finance_internationalBill: 'Международный счет',
  finance_collectAndPrepaid: 'Инкассо и авансирование',
  finance_fileHistory: 'История документов',
  finance_exportExcelAll: 'Экспорт всего',
  finance_updateBusinessDate: 'Изменение даты операции',
  finance_log: 'Журнал',
  finance_allowChange: 'Разрешить изменение заказа',
  finance_checkChange: 'Проверка изменения заказа',
  finance_batchCheckChange: 'Массовая проверка изменений заказов',
  finance_revokeChangeCommit: 'Отозвать подачу изменения заказа',
  charge_receivables: 'Дебиторская задолженность',
  charge_equivalent: 'Конвертация',
  charge_inviteToConfirmTheCharges: 'Подтверждение расходов по приглашению',
  charge_newAdjustment: 'Добавить корректировку',
  charge_editAdjustment: 'Изменить корректировку',
  charge_deleteAdjustment: 'Удалить корректировку',
  charge_writeOffList: 'Детали погашения',
  charge_chargesReject: 'Отклонение расходов',
  charge_chargeItem: 'Наименование расхода',
  charge_settleAccountsTo: 'Объект расчета',
  charge_invoiceHeader: 'Реквизиты счета',
  charge_somesticOrInternational: 'Внутренний/международный',
  charge_drawABillOrNot: 'Требуется ли счет',
  charge_currency: 'Валюта',
  charge_localCurrency: 'Базовая валюта',
  charge_exchangeRate: 'Курс обмена',
  charge_unit: 'Единица измерения',
  charge_amount: 'Количество',
  charge_unitPrice: 'Цена за единицу',
  charge_taxIncludedPrice: 'Цена с налогом',
  charge_taxExcludedPrice: 'Цена без налога',
  charge_taxRate: 'Налоговая ставка',
  charge_whtTaxRate: 'Ставка налога у источника (WHT)',
  charge_payables: 'К оплате',
  charge_controlled: 'Контролируемый',
  charge_cancelControlled: 'Снять контроль',
  charge_taxAmount: 'Сумма налога',
  charge_whtTaxAmount: 'Налог у источника (WHT)',
  charge_whtTaxLocalAmount: 'Налог у источника (WHT) в базовой валюте',
  charge_notWhtAmount: 'Сумма без WHT',
  charge_remarks: 'Примечание',
  charge_contactPerson: 'Контактное лицо',
  charge_relatedBLNo: 'Связанный номер коносамента',
  charge_relatedContainerNo: 'Связанный номер контейнера',
  charge_freightCollectOrPrepaid: 'Предоплата/оплата при получении',
  charge_status: 'Статус',
  charge_conversionRMB: 'Эквивалент в RMB',
  charge_confirmOrNot: 'Подтверждено',
  charge_billNo: 'Номер счета',
  charge_agent_billNo: 'Номер счета агентского вознаграждения',
  charge_containerNo: 'Номер контейнера',
  charge_invoiceNo: 'Номер счета-фактуры',
  charge_invoiceDate: 'Дата выставления счета',
  charge_agentBillNo: 'Номер счета контрагента',
  charge_theAmountOfWriteOffs: 'Сумма списания',
  charge_writeOffDate: 'Дата списания',
  charge_financialDate: 'Финансовая дата',
  charge_businessNumber: 'Бизнес-номер',
  charge_creator: 'Создатель',
  charge_createTime: 'Время создания',
  charge_editor: 'Изменивший',
  charge_editTime: 'Время изменения',
  charge_paymentApplicationNo: 'Номер заявки на оплату',
  charge_profit: 'Прибыль',
  charge_profitAll: 'Общая прибыль',
  charge_estimateRemarks: 'Примечание к оценке',
  charge_showRedCharges: 'Показать сторнированные расходы',
  charge_auditor: 'Проверяющий',
  charge_estimate: 'Оценка',
  charge_add: 'Добавить',
  charge_copy: 'Копировать расходы',
  charge_delete: 'Удалить',
  charge_edit: 'Изменить',
  charge_chargesAudit: 'Проверка расходов',
  charge_cancelTheAudit: 'Отменить проверку',
  charge_showCommonCharge: 'Показать обычные расходы',
  charge_showSpecialCharge: 'Показать специальные расходы',
  charge_sp1: 'Тарифный номер',
  charge_sp2: 'Нажмите, чтобы скопировать номер тарифа',
  charge_sp3: 'Добавить по услуге',
  charge_sp4: 'Обновить курс валюты',
  charge_sp5: 'Записать расходы по чеку',
  charge_sp6: 'Записать кредиторскую задолженность',
  charge_sp7: 'Схема расходов',
  charge_sp8: 'Тарифная таблица',
  charge_sp9: 'Отменить отправку',
  charge_sp10: 'Отправить расходы',
  charge_sp11: 'Распределение затрат',
  charge_sp12: 'Показать расходы по разделённым счетам',
  charge_sp13: 'Услуги',
  charge_copyCost: 'Записать дебиторскую задолженность',
  charge_copyCharge: 'Записать расходы',
  charge_payReceiveDate: 'Дата поступления/оплаты',
  charge_actualAmountNo: 'Номер проводки по списанию',
  charge_newChange: 'Добавить расходы на изменение заказа',
  charge_editChange: 'Изменить расходы на изменение заказа',
  charge_deleteChange: 'Удалить расходы на изменение заказа',
  charge_shared: 'Распределение',
  charge_showSharedCharges: 'Показать распределённые расходы',
  charge_newSpecial: 'Добавить специальные расходы',
  charge_editSpecial: 'Редактировать специальные расходы',
  charge_unitPriceIncludeTax: 'Включает ли цена налог',
  charge_locked_status: 'Заблокировано ли',
  domestic_showAllBilling: 'Показать все счета',
  domestic_commissionedChargesOnly: 'Показать только расходы по данному поручению',
  domestic_newReceivables: 'Создать дебиторскую задолженность',
  domestic_newPayables: 'Создать кредиторскую задолженность',
  domestic_edit: 'Редактировать',
  domestic_delete: 'Удалить',
  domestic_view: 'Просмотреть',
  domestic_confirm: 'Подтвердить',
  domestic_cancelConfirm: 'Отменить подтверждение',
  domestic_billNo: 'Номер счёта',
  domestic_settleAccountTto: 'Объект расчёта',
  domestic_settlementAgent: 'Расчётный агент',
  domestic_invoiceHeader: 'Название в счете',
  domestic_currency: 'Валюта',
  domestic_chargeAmount: 'Сумма',
  domestic_totalCurrency: 'Итого по валютам',
  domestic_revenueAndExpenditureType: 'Тип дохода/расхода',
  domestic_confirmationStatus: 'Статус подтверждения',
  domestic_invoicingStatus: 'Статус выставления счёта',
  domestic_writeOffStatus: 'Статус списания',
  domestic_revenueOrExpenditure: 'Доходы и расходы',
  domestic_chargeItem: 'Наименование расхода',
  domestic_unit: 'Единица измерения',
  domestic_amount: 'Количество',
  domestic_unitPrice: 'Цена за единицу',
  domestic_taxIncludedPrice: 'Цена с налогом',
  domestic_taxExcludedPrice: 'Цена без налога',
  domestic_taxRate: 'Налоговая ставка',
  domestic_taxAmount: 'Сумма налога',
  domestic_remarks: 'Примечание',
  domestic_billingGroupNo: 'Номер сверки',
  domestic_billingBranchId: 'Филиал счета',
  international_showAllBilling: 'Показать все счета',
  international_commissionedChargesOnly: 'Показать только расходы по данному поручению',
  international_add: 'Добавить',
  international_edit: 'Редактировать',
  international_delete: 'Удалить',
  international_audit: 'Проверить',
  international_invalid: 'Аннулировать',
  international_agentProfitShareBillNo: 'Счет агентского вознаграждения',
  international_printAllAgentProfitShareBillNo: 'Распечатать все счета агентского вознаграждения',
  international_editAgentBillNo: 'Редактировать номер счета контрагента',
  international_billNo: 'Номер счета',
  international_agentBillNo: 'Номер счета контрагента',
  international_revenueAndExpenditureType: 'Тип дохода/расхода',
  international_settleAccountTo: 'Объект расчета',
  international_settlementAgent: 'Агент расчета',
  international_currency: 'Валюта',
  international_chargeAmount: 'Сумма',
  international_status: 'Статус',
  international_billType: 'Тип счета',
  international_invoicingStatus: 'Статус выставления счета',
  international_writeOffStatus: 'Статус погашения',
  international_billDtae: 'Дата счета',
  international_creator: 'Создатель',
  international_businessNumber: 'Номер операции',
  international_billingGroupNo: 'Номер сверки',
  international_revenueOrExpenditure: 'Доходы/расходы',
  international_chargeItem: 'Наименование расхода',
  international_taxIncludedPrice: 'Цена с налогом',
  international_taxExcludedPrice: 'Цена без налога',
  international_taxRate: 'Налоговая ставка',
  international_taxAmount: 'Сумма налога',
  international_unit: 'Единица измерения',
  international_amount: 'Количество',
  international_unitPrice: 'Цена за единицу',
  international_remarks: 'Примечание',
  adChargeInfo_prepaid: 'Авансирование',
  adChargeInfo_print: 'Печать',
  adChargeInfo_newAdjustment: 'Добавить корректировку',
  adChargeInfo_editAdjustment: 'Изменить корректировку',
  adChargeInfo_deleteAdjustment: 'Удалить корректировку',
  adChargeInfo_addBoth: 'Добавить одновременно',
  adChargeInfo_add: 'Добавить',
  adChargeInfo_delete: 'Удалить',
  adChargeInfo_chargeItem: 'Наименование расхода',
  adChargeInfo_settleAccountsTo: 'Объект расчёта',
  adChargeInfo_domesticOrInternational: 'Внутренний/зарубежный',
  adChargeInfo_currency: 'Валюта',
  adChargeInfo_unit: 'Единица измерения',
  adChargeInfo_quantity: 'Количество',
  adChargeInfo_unitPrice: 'Цена за единицу',
  adChargeInfo_exchangeRate: 'Курс обмена',
  adChargeInfo_amount: 'Сумма',
  adChargeInfo_remarks: 'Примечание',
  adChargeInfo_billNo: 'Номер счёта',
  adChargeInfo_taxNo: 'Номер налога',
  arChargeInfo_theAmountOfWriteOffs: 'Сумма списания',
  apChargeInfo_theAmountOfWriteOffs: 'Сумма списания',
  adChargeInfo_collect: 'Инкассо',
  adChargeInfo_submitCharge: 'Отправить расходы',
  adChargeInfo_cancelSubmit: 'Отменить отправку',
  adChargeInfo_status: 'Статус',
  adChargeInfo_paymentApplicationNo: 'Номер заявки на оплату',
  international_forceDelete: 'Принудительное удаление',
  return: 'Назад',
  Confirm: 'Подтвердить',
  Cancel: 'Отмена',
  accrualDate: 'Дата начисления',
  adjustmentItem: 'Статья корректировки',
  adjustmentValue: 'Значение корректировки',
  charge_ProvisionedDate: 'Дата начисления',
  charge_specialUpdate: 'Корректировка специальных расходов',
  charge_settleDepartmentPrefix: 'Расчётный отдел',
  charge_paymentApplicationDateCreated: 'Дата создания заявки на оплату',
  charge_SapStatus: 'Статус SAP',
  finance_ChargeCommit: 'Отправка изменённого документа',
  separateAllocation: 'Распределение по документам',
  allocationType: 'Тип распределения',
  costSharingValue: 'Значение распределения расходов',
  modifyField: 'Изменение поля',
  operationContent: 'Содержание операции',
  statusAfterOperation: 'Статус после операции',
  routeLeader: 'Ответственный за маршрут',
  selectAdjustmentItem: 'Выберите статью корректировки',
  businessInfoAdjustedSuccess: 'Корректировка бизнес-информации успешно выполнена',
  apportionedTax: 'Распределение налога',
  charge_asyncCharges: 'Синхронизация расходов',
  charge_asyncChargeRecords: 'Запись синхронизации расходов',
  lockBusinessSuccess: 'Блокировка документа успешно выполнена',
  AccountVerifyBusinessSuccess: 'Проверка успешно выполнена',
  AccrualSucceeded: 'Начисление успешно выполнено',
  charge_asyncChargesToImportJob: 'Синхронизация с импортными операциями',
  charge_syncChargesConfirmStatus: 'Статус синхронизации расходов',
  charge_cancelSyncChargesConfirmStatus: 'Отмена статуса синхронизации расходов',
  charge_syncChargesToSI: 'Синхронизация затрат на реимпорт',
  charge_cancelSyncChargesToSI: 'Отмена синхронизации затрат на реимпорт',
  charge_paymentAmount: 'Сумма к получению/оплате',
  expenseSharingReceipt: 'Чек распределения затрат',
  correspondingAllocationBusiness: 'Соответствующие распределенные операции',
  allocateRelatedBusinesses: 'Связанные распределенные операции',
  BusinessSyncModifyBusinessDate: 'Дата экспортной операции будет синхронно изменена',
  ImportBusinessSyncModifyBusinessDate: 'Дата импортной операции будет синхронно изменена',
  ExportBusinessItemCannotEmpty: 'Это поле в экспортной операции не может быть пустым',
  ImportBusinessItemCannotEmpty: 'Это поле в импортной операции не может быть пустым',
  LandTransportationBusinessItemCannotEmpty: 'Это поле в автотранспортной операции не может быть пустым',
  synchronizationFeesToBeProcessed: 'Ожидает обработки синхронизация затрат',
  markAsRead: 'Пометить как прочитанное',
  fail: 'Не утверждено',
  applyRecallCharge: 'Запрос на отзыв затрат',
  recallState: 'Статус отзыва',
  recallCause: 'Причина отзыва',
  youCanOnlyOperateOnConfirmedCharges: 'Действия возможны только с подтвержденными затратами',
  thereAreCostsThatHaveBeenWithdrawn: 'Имеются уже отозванные затраты, не отправляйте повторно',
  theFeeHasEnteredTheSettlementProcess: 'Затраты уже в процессе расчета, отзыв невозможен. Необходимо отменить связь с документами: подтверждение сверки, счета, накладные, заявки на оплату, записи о погашении.',
  PleaseSeparateTheFeesForConfirmationAndWithdrawal: 'Затраты, ожидающие первичного подтверждения и запрошенные к отзыву, обрабатывайте отдельно',
  receivablePayable: 'Дебиторская/кредиторская задолженность',
  currency: 'Валюта',
  sender: 'Отправитель',
  receiver: 'Получатель',
  syncProgress: 'Ход синхронизации',
  processingStatus: 'Статус обработки',
  sendingTime: 'Время отправки',
  auditOperationTime: 'Время проверки',
  pending: 'Ожидает обработки',
  alreadyRead: 'Прочитано',
  notRead: 'Не прочитано',
  businessHasBeenSubmitted: 'Операция уже отправлена, нельзя утвердить и добавить затраты. При необходимости обратитесь к руководителю для отмены отправки.',
  selectBeConfirmedChargeByUs: 'Выберите затраты, ожидающие нашего подтверждения',
  selectRejectedChargeByOppositeParty: 'Выберите затраты, отклоненные контрагентом',
  pleaseSaveTheCurrentPageFirst: 'Сначала сохраните текущую страницу',
  commissionAmount: 'Сумма комиссионных',
  charge_writeOffDate_ar: 'Дата погашения',
  charge_writeOffDate_ap: 'Дата погашения',
  GenerateVoucher: 'Сформирован ли документ',
  CurrencyAccountsReceivable: 'Дебиторская задолженность по валютам:',
  CurrencyAccountsPayable: 'Кредиторская задолженность по валютам:',
  today: 'Сегодня',
  thisMonthEnd: 'Конец текущего месяца',
  previousMonthEnd: 'Конец прошлого месяца',
  IssueMonthOfYear: '{0} год, {1}-й период',
  QMonthYear: '{0} год, {1}-й квартал',
  XYear: '{0} год',
  SongtiSerif: 'Шрифт SimSun, serif',
  TrialBalance: 'Оборотно-сальдовая ведомость',
  BalanceSheetWithContacts: 'Ведомость остатков по взаимным расчетам',
  StatementOfAccountWithContacts: 'Сверка взаимных расчетов',
  SubsidiaryLedger: 'Аналитический учет',
  GeneralLedger: 'Главная книга',
  Receive: 'Приход',
  Pay: 'Расход',
  Transfer: 'Перевод',
  ForeignCurrencyRevaluation: 'Корректировка курса на конец периода',
  RetainedEarnings: 'Перенос прибылей и убытков текущего периода',
  Billion: '100 миллионов',
  Thousand: 'Тысяча',
  Hundred: 'Сто',
  Ten: 'Десять',
  TenThousand: '10 тысяч',
  Yuan: 'Юань',
  Dime: 'Цзяо',
  Cent: 'Фэнь',
  FailedObtainCurrentFiscalPeriod: 'Не удалось получить текущий финансовый период!',
  Total: 'Итого',
  Quantity: 'Количество:',
  UnitPrice: 'Цена за единицу:',
  ForeignCurrency: 'Исходная валюта:',
  UnbalancedDebitAndCreditEntry: 'Дебет и кредит не сбалансированы!',
  ThisVoucherPleaseEditInModule: 'Этот документ является операционным. \nПожалуйста, отредактируйте его в модуле "Генерация документов"',
  ForeignCurrencyCannotBeEmpty: 'Исходная валюта не может быть пустой',
  ClientItemCannotBeEmpty: 'Вспомогательное поле "Клиент" не может быть пустым',
  SupplierItemCannotBeEmpty: 'Вспомогательное поле "Поставщик" не может быть пустым',
  StaffItemCannotBeEmpty: 'Вспомогательное поле "Сотрудник" не может быть пустым',
  ProjectItemCannotBeEmpty: 'Вспомогательное поле "Проект" не может быть пустым',
  DepartmentItemCannotBeEmpty: 'Вспомогательное поле "Отдел" не может быть пустым',
  Client: 'Клиент',
  Supplier: 'Поставщик',
  Department: 'Отдел',
  Staff: 'Сотрудник',
  Project: 'Проект',
  Currency: 'Валюта:',
  Amount: 'Сумма:',
  ExchangeRate: 'Курс обмена:',
  All: 'Все',
  Yes: 'Да',
  No: 'Нет',
  Year: 'Год',
  Period: 'Период',
  PleaseSelectVoucherRange: 'Пожалуйста, выберите диапазон документов',
  Assets: 'Активы',
  Liabilities: 'Обязательства',
  Equity: 'Капитал',
  Cost: 'Себестоимость',
  ProfitAndLoss: 'Прибыли и убытки',
  ClientSupplier: 'Клиент/Поставщик',
  BalanceInRMB: 'Остаток в юанях',
  UnmatchedClientOrSupplier: 'Несопоставленные клиенты или поставщики',
  AddAssetAccount: 'Добавить статью активов',
  Add: 'Добавить',
  Edit: 'Редактировать',
  Delete: 'Удалить',
  AddCashFlowItem: 'Добавить статью денежных потоков',
  ImportSucceeded: 'Импорт успешно завершен',
  DesignSubaccounts: 'Создать субсчет',
  NeedToExport: 'Требуется экспорт',
  NoExportNeeded: 'Не требуется экспорт',
  SeparatorSettings: 'Настройка разделителя',
  ExportSeparator: 'Разделитель экспорта',
  Separator: 'Разделитель:',
  PleaseFinancialYearForReport: 'Укажите финансовый год для инициализации отчетности,',
  RepeatingDataLossPleaseCaution: 'Повторная инициализация приведет к потере сохраненных данных, используйте с осторожностью.',
  InitializationPleaseCheckAccountSettings: 'Инициализация успешно завершена, проверьте настройки счетов.',
  InitializationPleaseCheckTheReport: 'Инициализация успешно завершена, проверьте отчеты.',
  DetailedEntryRulesConfiguration: 'Настройка правил проводок',
  FeeWillBeDeleted: 'Примечание: будет удалено {0} расходов',
  AccountNotFound: 'Учетная система не существует',
  Quarter: 'Квартал',
  AccountingVoucher: 'Бухгалтерская проводка',
  StatusUnknown: 'Статус неизвестен',
  N0Year0Period: '{0} год, период {1}',
  SyncCloudSucceededXFailedX: 'Синхронизация с Cloud Star успешна: {0}, неудачно: {1}',
  SyncExceptionReason: 'Причина ошибки синхронизации',
  SyncCloudStarrySky: 'Синхронизировать с Cloud Star',
  SyncFeeCannotSyncAgain: 'Уже синхронизированные расходы нельзя синхронизировать повторно!',
  DisplayTransactions: 'Показать операции по контрагентам',
  EnterBusinessNumberBeforeQuery: 'Введите номер операции для поиска',
  SelectNewEncodingType: 'Выберите тип нового кода',
  SelectMatchingPartnerFieldType: 'Выберите тип поля для сопоставления партнеров',
  NewEncodingType: 'Тип нового кода:',
  CustomerCode: 'Код клиента',
  SupplierCode: 'Код поставщика',
  AtLeastOneCustomerAndSupplierCode: 'Необходимо выбрать хотя бы один код: клиента или поставщика',
  MatchPartnerFieldTypes: 'Тип поля для сопоставления партнеров:',
  PartnersCode: 'Партнер_код',
  PartnersNumber: 'Партнер_номер',
  PartnersChineseName: 'Партнер_название на китайском',
  ImportCustomerAndProviderCode: 'Подтверждаете импорт [{0}] в качестве кода клиента и поставщика для партнеров этой учетной системы?',
  ImportCustomerCode: 'Подтверждаете импорт [{0}] в качестве кода клиента для партнеров этой учетной системы?',
  ImportProviderCode: 'Подтверждаете импорт [{0}] в качестве кода поставщика для партнеров этой учетной системы?',
  ImportCodePenddingTip: 'Импорт кодов контрагентов...<br>Закрытие страницы не прервет импорт, вы получите уведомление по завершении.',
  ModifyExpirationDate: 'Изменить срок действия',
  ModifyChargeExpirationDate: 'Изменить срок действия расходов',
  RemoveCountFee: 'Удалите уже рассчитанные расходы',
  ChargeHqCurrency: 'Локальная валюта HQ',
  ChargeHqRate: 'Курс локальной валюты HQ',
  CostType: 'Тип затрат',
  HideForeignCurrencyProfitLoss: 'Не отображать перенос прибылей и убытков в иностранной валюте',
  GpExplain: 'Пояснение GP',
  Peer: 'Является ли доверенная организация конкурентом',
  ProfitRate: 'Рентабельность',
  ArRowsAndApRows: 'Количество строк дебиторской/кредиторской задолженности',
  ArIncludeAp: 'Дебиторская задолженность включает кредиторскую',
  Allocation: 'Allocation',
  LclTicketsCanNotAudit: 'Частичные накладные не могут быть проверены отдельно, проверьте основную накладную.',
  SelectedDataJobSubmitNotAllowAudit: 'Выбранные данные содержат одинаковых отправителя и проверяющего, проверка запрещена, проверьте!',
  SelectedDataJobSubmitNotAllowCancelAudit: 'Выбранные данные содержат одинаковых отправителя и проверяющего, отмена проверки запрещена, проверьте!',
  SelectedDataChargeByNotAllowCancelAudit: 'Выбранные данные содержат одинаковых отправителя изменений и проверяющего, проверка запрещена, проверьте!',
  JobSubmitNotAllowAudit: 'Отправитель и проверяющий одинаковы, проверка запрещена!',
  JobSubmitNotAllowCancelAudit: 'Отправитель и проверяющий одинаковы, отмена проверки запрещена!',
  JobSubmitNotAllowCancelChangeOrder: 'Отправитель и проверяющий одинаковы, изменение запрещено!',
  ChargeSubmitNotAllowAudit: 'Отправитель расходов и проверяющий одинаковы, проверка запрещена!',
  ChargeSubmitNotAllowCancelAudit: 'Отправитель расходов и проверяющий одинаковы, отмена проверки расходов запрещена!',
  ChargeSubmitNotAllowCancelChangeOrder: 'Отправитель расходов и проверяющий одинаковы, проверка изменений запрещена!',
  AdditionalCostRemarks: 'Примечание к дополнительным расходам',
  AdditionalCostRemarksContent: 'Содержание примечания к дополнительным расходам',
  JobSubmitNotAllowCancelAdjustCosts: 'Отправитель и проверяющий одинаковы, корректировка расходов запрещена!'
}
